import { TableCell, TableRow } from "components";
import dayjs from "dayjs";
import { useGetMonths } from "hooks/useGetMonths";
import useQueryHook from "hooks/useQueryHook";
import { get } from "lodash";
import { FC, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export interface IMonthlyPaymentTableHeadProps { }

export const MonthlyPaymentTableHead: FC<IMonthlyPaymentTableHeadProps> = () => {
  const { t } = useTranslation();
  const months = useGetMonths();
  const { AddQueryParams, QueryParams } = useQueryHook();


  const scrollToCurrentMonth = () => {
    const currentMonth = dayjs().month();
    const currentYear = dayjs().year();

    const foundItem = months.find((attend: Record<string, any>) => {
      const attendTime = dayjs().month(attend.monthNumber - 1).year(attend.year);
      return attendTime.month() === currentMonth && attendTime.year() === currentYear;
    });

    if (foundItem) {
      const element = document.getElementById(`attend-${foundItem.monthNumber}-${foundItem.year}`);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", inline: "center" });
        }, 500);
      }
    }
  };

  useEffect(() => {
    if (months.length > 0) {
      scrollToCurrentMonth();
    }
  }, [months]);

  const theme = localStorage.getItem('theme')


  return (
    <>
      <TableRow>
        <TableCell align="center" className={`font-bold sticky left-0 z-30 w-[50px] min-w-[50px] max-w-[50px] ${theme === "light" ? "bg-[#F5F5F5]" : "bg-[#102231]"}`} rowSpan={2}>
          №
        </TableCell>
        {/* <TableCell align="center" className="font-bold sticky left-[30px] z-10" rowSpan={2}>
          {t("TABLE.CONTRACT_NUMBER")}
        </TableCell> */}
        <TableCell align="center" className={`sticky left-[49px] z-30 w-[200px] min-w-[200px] max-w-[200px] ${theme === "light" ? "bg-[#F5F5F5]" : "bg-[#102231]"}`} rowSpan={2}>
          {t("TABLE.NAME_SURNAME")}
        </TableCell>
        <TableCell align="center" className={`sticky left-[248px] z-30 w-[100px] min-w-[100px] max-w-[100px] ${theme === "light" ? "bg-[#F5F5F5]" : "bg-[#102231]"}`} rowSpan={2}>
          {t("TABLE.CLASS")}
        </TableCell>
        <TableCell align="center" className={`sticky left-[347px] z-30 w-[150px] min-w-[150px] max-w-[150px] ${theme === "light" ? "bg-[#F5F5F5]" : "bg-[#102231]"}`} rowSpan={2}>
          {t("TABLE.PHONE_NUMBER")}
        </TableCell>
        {months.filter((month) =>
          QueryParams.month ? month.monthNumber === +QueryParams.month : true
        ).map((item) => (
          <TableCell id={`attend-${item.monthNumber}-${item.year}`} align="center" className={`font-bold sticky z-20 top-0 ${theme === "light" ? "bg-[#F5F5F5]" : "bg-[#102231]"}`} colSpan={2} key={`${item.monthNumber}-${item.year}`}>
            <p className=" text-nowrap"> {`${item.month} ${item.year}`}</p>
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {months.filter((month) =>
          QueryParams.month ? month.monthNumber === +QueryParams.month : true
        ).map(() => (
          <>
            <TableCell className="font-bold" align="center">
              {t("general.status")}
            </TableCell>
            <TableCell className="font-bold" align="center">
              {t("general.comment")}
            </TableCell>
          </>
        ))}
      </TableRow>
    </>
  );
};
